/* Dust & Mile /cart page: quantity + remove via /cart/change, re-rendering this section,
 * the cart drawer and the header bubble; aria-live status; mobile sticky checkout bar. */
(function () {
  if (customElements.get('dm-cart-page')) return;

  var STATUS_UPDATING = 'Updating your cart…';
  var STATUS_DONE = 'Your cart has been updated';
  var STATUS_ERROR = 'Something went wrong. Please refresh and try again.';

  class DmCartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.timers = new Map();

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.dmOrigin === 'dm-cart-page') return;
          this.refresh();
        });
      }

      this.onDrawerOpen = () => {
        this.drawerOpen = true;
        this.updateSticky();
      };
      this.onDrawerClose = () => {
        this.drawerOpen = false;
        this.updateSticky();
      };
      document.addEventListener('dm:cart-drawer:open', this.onDrawerOpen);
      document.addEventListener('dm:cart-drawer:close', this.onDrawerClose);

      this.setupSticky();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.io) this.io.disconnect();
      document.removeEventListener('dm:cart-drawer:open', this.onDrawerOpen);
      document.removeEventListener('dm:cart-drawer:close', this.onDrawerClose);
      document.body.classList.remove('dm-cart-has-sticky');
    }

    /* ---------- events ---------- */
    lineOf(el) {
      return el.closest('[data-dm-line-key]');
    }

    onClick(event) {
      var stepBtn = event.target.closest('[data-dm-step]');
      var removeBtn = event.target.closest('[data-dm-remove]');
      if (stepBtn) {
        event.preventDefault();
        var line = this.lineOf(stepBtn);
        var input = line && line.querySelector('[data-dm-qty]');
        if (!input) return;
        var step = parseInt(input.step, 10) || 1;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + step * parseInt(stepBtn.dataset.dmStep, 10));
        if (input.max && next > parseInt(input.max, 10)) next = parseInt(input.max, 10);
        input.value = next;
        this.queue(line, next, stepBtn.dataset.dmFocus, 300);
      } else if (removeBtn) {
        event.preventDefault();
        this.commit(this.lineOf(removeBtn), 0, 'remove');
      }
    }

    onInput(event) {
      var input = event.target.closest('[data-dm-qty]');
      if (!input || input.value === '') return;
      this.queue(this.lineOf(input), parseInt(input.value, 10), 'input', 450);
    }

    onChange(event) {
      var input = event.target.closest('[data-dm-qty]');
      if (!input) return;
      if (input.value === '') input.value = input.getAttribute('value');
    }

    onKeydown(event) {
      var input = event.target.closest('[data-dm-qty]');
      if (!input || event.key !== 'Enter') return;
      event.preventDefault();
      if (input.value === '') return;
      this.commit(this.lineOf(input), parseInt(input.value, 10), 'input');
    }

    queue(line, qty, focusName, wait) {
      if (!line) return;
      var key = line.dataset.dmLineKey;
      clearTimeout(this.timers.get(key));
      this.timers.set(
        key,
        setTimeout(() => {
          this.timers.delete(key);
          this.commit(line, qty, focusName);
        }, wait)
      );
    }

    /* ---------- update ---------- */
    commit(line, qty, focusName) {
      if (!line || isNaN(qty) || qty < 0) return;
      var key = line.dataset.dmLineKey;
      clearTimeout(this.timers.get(key));
      this.timers.delete(key);

      var input = line.querySelector('[data-dm-qty]');
      if (input && qty === parseInt(input.getAttribute('value'), 10) && focusName !== 'remove') return;

      this.setStatus(STATUS_UPDATING);
      this.classList.add('is-updating');
      line.classList.add('is-loading');

      var body = JSON.stringify({
        id: key,
        quantity: qty,
        sections: [this.sectionId, 'cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      var lineIndex = Array.prototype.indexOf.call(this.querySelectorAll('[data-dm-line-key]'), line);

      fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig(), { body: body }))
        .then((r) => r.json())
        .then((state) => {
          if (state.errors || state.status) {
            var msg = typeof state.errors === 'string' ? state.errors : state.description || STATUS_ERROR;
            if (input) input.value = input.getAttribute('value');
            var err = line.querySelector('[data-dm-line-error]');
            if (err) err.textContent = msg;
            this.setStatus(msg);
            return;
          }

          this.renderSelf(state.sections && state.sections[this.sectionId]);
          if (window.dmCart) {
            window.dmCart.renderSections(state.sections);
          }
          this.restoreFocus(key, focusName, lineIndex);
          this.setStatus(STATUS_DONE);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              dmOrigin: 'dm-cart-page',
              cartData: state,
            });
          }
        })
        .catch(() => {
          if (input) input.value = input.getAttribute('value');
          this.setStatus(STATUS_ERROR);
        })
        .finally(() => {
          this.classList.remove('is-updating');
          if (line.isConnected) line.classList.remove('is-loading');
        });
    }

    renderSelf(html) {
      if (!html) return this.refresh();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('dm-cart-page');
      if (!fresh) return;
      var status = this.querySelector('[data-dm-cart-status]');
      var statusText = status ? status.textContent : '';
      this.innerHTML = fresh.innerHTML;
      var newStatus = this.querySelector('[data-dm-cart-status]');
      if (newStatus) newStatus.textContent = statusText;
      this.setupSticky();
    }

    refresh() {
      if (!this.sectionId) return;
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(this.sectionId))
        .then((r) => r.text())
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('dm-cart-page');
          if (!fresh) return;
          this.innerHTML = fresh.innerHTML;
          this.setupSticky();
        })
        .catch(() => {});
    }

    restoreFocus(key, focusName, lineIndex) {
      var line = this.querySelector('[data-dm-line-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      var target = null;
      if (line && focusName && focusName !== 'remove') {
        target = line.querySelector('[data-dm-focus="' + focusName + '"]');
        if (target && target.disabled) target = line.querySelector('[data-dm-qty]');
      }
      if (!target) {
        var lines = this.querySelectorAll('[data-dm-line-key]');
        var neighbour = lines[Math.min(lineIndex, lines.length - 1)];
        target = neighbour ? neighbour.querySelector('[data-dm-remove]') : null;
      }
      if (!target) target = this.querySelector('[data-dm-cart-title]') || this.querySelector('a');
      if (target) target.focus({ preventScroll: focusName === 'remove' ? false : true });
    }

    setStatus(text) {
      var status = this.querySelector('[data-dm-cart-status]');
      if (status) status.textContent = text;
    }

    /* ---------- mobile sticky checkout ---------- */
    setupSticky() {
      if (this.io) this.io.disconnect();
      this.sticky = this.querySelector('[data-dm-sticky]');
      var mainBtn = this.querySelector('[data-dm-main-checkout]');
      document.body.classList.toggle('dm-cart-has-sticky', !!this.sticky);
      if (!this.sticky || !mainBtn) return;

      if (this.mainVisible === undefined) this.mainVisible = false;
      if ('IntersectionObserver' in window) {
        // The bar steps aside once the order totals reach the area above it, so it never covers
        // the subtotal, the "You're saving" line or the main checkout button
        var watched = [this.querySelector('.dm-summary__totals'), this.querySelector('.dm-summary__savings'), mainBtn].filter(Boolean);
        var seen = new Set();
        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) seen.add(entry.target);
              else seen.delete(entry.target);
            });
            this.mainVisible = seen.size > 0;
            this.updateSticky();
          },
          { rootMargin: '0px 0px -130px 0px' }
        );
        watched.forEach((el) => this.io.observe(el));
      }
      var drawer = document.querySelector('cart-drawer');
      this.drawerOpen = !!(drawer && drawer.classList.contains('active'));
      this.updateSticky();
    }

    updateSticky() {
      if (!this.sticky) return;
      var hide = this.mainVisible || this.drawerOpen;
      this.sticky.classList.toggle('is-hidden', !!hide);
    }
  }

  customElements.define('dm-cart-page', DmCartPage);
})();
